import React, { useEffect, useState } from "react";
import { MessageSquare } from "lucide-react";
import api from "@/lib/api";

export default function MeetingChatInboxPage() {
  const [threads, setThreads] = useState(null);
  const [activeId, setActiveId] = useState(null);
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    api.get("/meetings/chats/recent").then((r) => {
      setThreads(r.data);
      if (r.data.length > 0) setActiveId(r.data[0].meeting_id);
    }).catch(() => setThreads([]));
  }, []);

  useEffect(() => {
    if (!activeId) return;
    api.get(`/meetings/${activeId}/chat`).then((r) => setMessages(r.data)).catch(() => setMessages([]));
  }, [activeId]);

  const activeTitle = threads?.find((t) => t.meeting_id === activeId)?.title;

  return (
    <div className="max-w-5xl mx-auto px-5 sm:px-8 py-8" data-testid="meeting-chat-inbox-page">
      <h1 className="font-heading text-2xl font-semibold text-white flex items-center gap-2"><MessageSquare className="w-6 h-6 text-teal-400" /> Chat</h1>
      <p className="text-sm text-slate-400 mt-1">Chat history from all your meetings and classes.</p>

      <div className="glass-panel rounded-2xl mt-6 grid sm:grid-cols-[220px_1fr] min-h-[400px] overflow-hidden">
        <div className="border-r border-white/5 divide-y divide-white/5 overflow-y-auto" data-testid="chat-threads-list">
          {threads === null && <p className="p-4 text-xs text-slate-400">Loading...</p>}
          {threads?.length === 0 && <p className="p-4 text-xs text-slate-400">No chats yet.</p>}
          {threads?.map((t) => (
            <button key={t.meeting_id} onClick={() => setActiveId(t.meeting_id)} data-testid={`chat-thread-${t.meeting_id}`}
              className={`w-full text-left p-3 hover:bg-white/5 ${activeId === t.meeting_id ? "bg-white/5" : ""}`}>
              <p className="text-sm text-white truncate">{t.title}</p>
              <p className="text-xs text-slate-500 truncate">{t.last_sender}: {t.last_message}</p>
            </button>
          ))}
        </div>
        <div className="p-4 overflow-y-auto" data-testid="chat-messages-panel">
          {!activeId && <p className="text-sm text-slate-500 text-center mt-8">Select a chat to view its history.</p>}
          {activeId && (
            <>
              <p className="text-sm font-semibold text-white mb-3">{activeTitle}</p>
              <div className="space-y-2">
                {messages.map((m) => (
                  <div key={m.id || m.sent_at} className="text-xs" data-testid={`chat-message-${m.id}`}>
                    <span className="font-semibold text-cyan-300">{m.name}: </span>
                    <span className="text-slate-300">{m.text}</span>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
